

  <!-- navbar starts -->
<mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark indigo">
  <mdb-navbar-brand>
      <a class="navbar-brand" href="#">TheMSpace</a>
  </mdb-navbar-brand>
  <links>
      <div class="collapse navbar-collapse">
          <ul class="navbar-nav mr-auto mt-lg-0">
            <li class="nav-item active">
              <a class="nav-link waves-light" mdbWavesEffect>Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
              <a class="nav-link waves-light" mdbWavesEffect>About us</a>
          </li>
          </ul>
      </div>
  </links>
</mdb-navbar>
<!-- navbar ends -->

<router-outlet></router-outlet>
<!-- <footer class="page-footer font-small indigo">

  <div class="footer-copyright text-center py-3">© 2021 Copyright:
    <a href=""> TheMSpace.com</a>
  </div>

</footer> -->

